import type { Pitstop } from '@/services/api/pitstops';

/**
 * The three position fields to send when saving a hub configured from a pitstop.
 *
 * Core declares latitude/longitude NOT NULL on Pitstop, so a hub picked from the
 * live list always carries them. The edit modal, though, can fall back to a
 * synthesised pitstop holding only a name and an ID, and this returns {} for that
 * case.
 *
 * Omitting the keys is the point, not an accident: the backend leaves an
 * already-stored position alone when they are absent, so editing a hub's opening
 * hours through the fallback path cannot wipe coordinates configured earlier.
 * Sending them as undefined would not be equivalent once serialised.
 *
 * Deliberately not importing the axios-backed API client at runtime — see the
 * type-only import above.
 */
export const hubPositionFrom = (
  pitstop: Pitstop | undefined
): { hubAddress?: string; hubLatitude?: string; hubLongitude?: string } =>
  pitstop?.latitude && pitstop?.longitude
    ? {
        hubAddress: pitstop.address,
        hubLatitude: pitstop.latitude,
        hubLongitude: pitstop.longitude,
      }
    : {};
